/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { FormikProps } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { ServiceType } from 'shared';

import { PriceEstimation } from '../../../components/PriceEstimation/PriceEstimation';
import { Namespaces } from '../../../i18n';
import { SystemConfigContextProvider } from '../../../providers/SystemConfigProvider';
import { PlanState } from '../../../store/plan/types';
import { useClusterPlanStyles } from '../../../styles/clusterPlan';
import { fetchSupportPlans } from '../../../utils/queryFns';
import { CreateClusterValues } from '../CreateClusterOverlay.types';

type CreateClusterStep3Props<Values> = FormikProps<Values> & {
  plan: PlanState;
  serviceType: ServiceType | undefined;
};

export function CreateClusterStepSummary<Values extends CreateClusterValues>(props: CreateClusterStep3Props<Values>) {
  const { values, serviceType } = props;

  const { t } = useTranslation(Namespaces.CreateCluster);
  const classes = useClusterPlanStyles();

  const { data: supportPlansData } = useQuery([fetchSupportPlans.key], fetchSupportPlans.fn, {
    refetchOnMount: true,
  });

  const support = supportPlansData?.payload.find(v => v.id === values.supportPlanId);

  return (
    <SystemConfigContextProvider>
      <div className={classes.root}>
        <div className={classes.stepTitle}>{t('step_3_title')}</div>
        <PriceEstimation
          cpuUnits={values.cpuUnits}
          memoryGbs={values.memoryGbs}
          storageGbs={values.storageGbs}
          replicas={values.replicas}
          postgresVersion={values.postgresVersion}
          supportPlan={support!}
          serviceType={serviceType}
        />
      </div>
    </SystemConfigContextProvider>
  );
}
